import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { utils } from 'gipsy-misc';
import { contact } from 'gipsy-api';
import { uploadImage } from '../TaskPanel/utils';
import View from './view';
import Disable from '../HOC/Disable';

var propTypes = {
  defaultReviewRequest: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  create: PropTypes.func,
  onUnmount: PropTypes.func,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  closePanel: PropTypes.func
};

var ReviewRequestPanel = function (_Component) {
  _inherits(ReviewRequestPanel, _Component);

  function ReviewRequestPanel(props) {
    _classCallCheck(this, ReviewRequestPanel);

    var _this = _possibleConstructorReturn(this, (ReviewRequestPanel.__proto__ || Object.getPrototypeOf(ReviewRequestPanel)).call(this, props));

    _initialiseProps.call(_this);

    var reviewRequest = props.defaultReviewRequest;
    _this.state = {
      reviewRequest: reviewRequest,
      defaultContacts: [],
      activePrompt: false
    };

    _this.fetchContacts();
    return _this;
  }

  _createClass(ReviewRequestPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.reviewRequest.id);
      }
    }

    /*
      paramName = task param to change
      value = new value
      method (change, add, remove) = method to follow, for an array we can add, change or remove an item (watchers, comments, tags)
    */

  }, {
    key: 'render',
    value: function render() {
      var reviewRequest = this.state.reviewRequest;


      return reviewRequest ? React.createElement(View, {
        reviewRequest: reviewRequest,
        defaultContacts: this.state.defaultContacts,
        onImageUpload: this.onImageUpload,
        create: this.create,
        onChange: this.onChange,
        disabled: this.props.disabled,
        handleAPIError: this.props.handleAPIError,
        progressPending: this.props.progressPending,
        progressSuccess: this.props.progressSuccess,
        progressError: this.props.progressError,
        hideWatchers: this.props.hideWatchers,
        hideWhen: this.props.hideWhen,
        closePanel: this.props.closePanel
      }) : null;
    }
  }]);

  return ReviewRequestPanel;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.fetchContacts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return contact.get('');

          case 3:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 6;
              break;
            }

            _context.t0 = [];

          case 6:
            result = _context.t0;

            _this2.setState({
              defaultContacts: result
            });
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t1 = _context['catch'](0);

            console.error(_context.t1);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this2, [[0, 10]]);
  }));

  this.setReviewRequest = function (reviewRequest) {
    if (_this2._isMounted) {
      _this2.setState({ reviewRequest: reviewRequest });
    }
  };

  this.create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var reviewRequest;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!_this2.props.disabled) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return');

          case 2:
            if (!_this2.props.create) {
              _context2.next = 9;
              break;
            }

            _this2.props.disable();

            reviewRequest = Object.assign({}, _this2.state.reviewRequest);

            reviewRequest.watchers = utils.user.cleanWatchers(reviewRequest.watchers);
            _context2.next = 8;
            return _this2.props.create(reviewRequest);

          case 8:
            /* should handle error  */
            if (_this2._isMounted) {
              _this2.props.enable();
            }

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  this.onChange = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
      var paramName = _ref4.paramName,
          value = _ref4.value,
          _ref4$method = _ref4.method,
          method = _ref4$method === undefined ? 'change' : _ref4$method;
      var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var oldValue, reviewRequest;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              /* check to avoid useless change and request */
              oldValue = get(_this2.state.reviewRequest, paramName);

              if (!(value === oldValue && method === 'change')) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt('return');

            case 3:
              reviewRequest = utils.task.computeTaskOnChange(_this2.state.reviewRequest, { paramName: paramName, value: value, method: method }, extraParams);


              _this2.setReviewRequest(reviewRequest);

              return _context3.abrupt('return');

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.onImageUpload = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(file, onUploadProgress) {
      var value;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return uploadImage(file, onUploadProgress);

            case 2:
              value = _context4.sent;

              _this2.onChange({ paramName: 'uploads', value: value, method: 'add' });
              return _context4.abrupt('return', value);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};

ReviewRequestPanel.propTypes = propTypes;

export default Disable()(ReviewRequestPanel);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ReviewRequestPanel/index.js
// module id = 1133
// module chunks = 0